import * as Yup from 'yup'

export const CreateContractorFileSchema = Yup.object().shape({
  name: Yup.string().required('This field is required'),
  file: Yup.string().required('This field is required'),
})
